import React, { FC } from 'react';

import { useHistory, useParams } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import { LearnerInfo, Tenant } from '../../types';
import { useAuth } from '../../utils/hooks';

//TODO replace to request
const SSO_CONNECTIONS = {
  cbi: {
    connection: 'CBI-Sustainability-Unlocked',
    tenant: 'sustainabilityunlocked',
  },
  zatca: {
    connection: 'Edcas-for-Zatca-Eacademy',
    tenant: 'euromoney',
  },
};

interface SsoLoginPageProps {
  userInfo: LearnerInfo;
  userLoading: boolean;
  tenant?: Tenant;
  loadingTenant: boolean;
}

const SsoLoginPage: FC<SsoLoginPageProps> = ({ userInfo, userLoading, tenant, loadingTenant }) => {
  const history = useHistory();
  const { ssoKey } = useParams();
  const { loginWithRedirect } = useAuth();

  const ssoKeyLower = ssoKey ? ssoKey.toLowerCase() : '';

  if (loadingTenant) {
    return <Loader />;
  } else if (!userLoading && userInfo) {
    history.replace('/home');
  } else if (
    !ssoKeyLower ||
    !SSO_CONNECTIONS[ssoKeyLower] ||
    SSO_CONNECTIONS[ssoKeyLower].tenant !== tenant?.name
  ) {
    history.replace('/404');
  } else {
    loginWithRedirect({
      redirectUri: '/home',
      isDirectUrl: true,
      connection: SSO_CONNECTIONS[ssoKeyLower].connection,
    });
  }

  return <Loader />;
};

export default SsoLoginPage;
